export const FABRIC_PANEL_TEST_IDS = {
  SEARCH_BTN: 'fabric-panel-search-btn',
  FILTER_BTN: 'fabric-panel-filter-btn',
  CARD_TEXT_MOBILE: 'card-text-mobile',
  CARD_SUBTEXT_MOBILE: 'card-subtext-mobile',
  CONFIRM_BTN_MOBILE: 'fabric-panel-confirm-btn-mobile',
  CONFIRM_BTN_DESKTOP: 'fabric-panel-confirm-btn-desktop',
  SUBGROUP_LIST: 'fabric-subgroup-list',
  LIST: 'fabric-panel-list',
  FILTER_COUNT: 'fabric-panel-filter-count',
  FILTER_BTN_DESKTOP: 'fabric-panel-filter-btn-desktop',
  SEARCH_BTN_DESKTOP: 'fabric-panel-search-btn-desktop',
  HEADER: 'fabric-panel-header',
  HEADER_DESKTOP: 'fabric-panel-header-desktop',
  HEADER_MOBILE: 'fabric-panel-header-mobile',
  SEARCH_INPUT: 'fabric-search-input',
} as const;

